import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {Link} from 'react-router-dom'

class Footer extends Component {

  constructor(props) {
    super(props)
    this.state = { year: new Date().getFullYear() }
  }
  render() {
    return (
      <footer>
        <ul className="site-link">
            &copy; {this.state.year} www.forrestsmietanski.com | <Link className=" pt-minimal" to={'/privacy'}>Privacy Policy</Link>
        </ul>
      </footer>
    )
  }
}

  export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx